import { HTMLAttributes, FC, useId } from "react";
import clsx from "classnames";
import { useStyles } from "./Toggle.style";

interface IToggleProps {
  checked?: boolean;
  onChange?: (checked?: boolean) => void;
  onClick?: (e?: React.SyntheticEvent | boolean) => void;
  disabled?: boolean;
}

export const Toggle: FC<IToggleProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { checked, onChange, disabled, id, onClick, ...othersProps } = props;
  const generatedId = useId();
  const inputId = id || `toggle-input-${generatedId}`;

  return (
    <span
      role="switch"
      aria-checked={!!checked}
      aria-disabled={disabled || undefined}
      tabIndex={-1}
      {...othersProps}
      className={clsx(classes.root, props.className)}
      onClick={(e) => {
        if (e.target === e.currentTarget && !disabled) {
          onChange?.(!checked);
        }
        onClick?.(e);
      }}
    >
      <input
        aria-hidden
        tabIndex={-1}
        className={classes.tgl}
        type="checkbox"
        id={inputId}
        checked={checked}
        onChange={(event) => onChange?.(event.target.checked)}
        disabled={disabled}
      />
      <label
        className={clsx(
          classes.genButton,
          "tgl-btn",
          disabled && classes.disabled,
          checked && classes.checked,
        )}
        htmlFor={inputId}
      />
      <div className={clsx(classes.circle, checked && classes.checked)} />
    </span>
  );
};
